var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"errPage-container"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('img',{attrs:{"src":_vm.errGif,"width":"313","height":"428","alt":"Girl has dropped her ice cream."}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }